// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interaction-data-card[data-v-73930d44]{height:100%}.interaction-data-content[data-v-73930d44]{height:calc(100% - 56px);overflow-y:auto;overflow-x:none;padding:2em}.interaction-data[data-v-73930d44]{float:left;width:50%}.bar div[data-v-73930d44]:first-child,.pie div[data-v-73930d44]:first-child{position:relative;height:300px}", ""]);
// Exports
module.exports = exports;
